import React from 'react';

/**
 * Returns a React "div" element containing the given string text as HTML.
 * @param {String} text The html text.
 * @return {React.Element} The react element.
 */
export const unsafeHtmlDiv = text => (
    <div dangerouslySetInnerHTML={{ __html: text }} />
);
